/** Default comptabilité module config — prefixes sync to settings.configuration.entityPrefixes */
export const DEFAULT_COMPTABILITE_ENTITY_PREFIXES = {
  journalEntry: 'ECR',
  balance: 'BALG',
  grandLivre: 'GRLV',
  bilan: 'BILA',
  accountChart: 'ACC',
  analyticalCode: 'ANL',
  comptabiliteCode: 'COD',
  operationCode: 'OPR',
  taxDeclaration: 'DEC',
};

export const DEFAULT_COMPTABILITE_CONFIG = {
  fiscalYearStart: 'january',
  accountingMethod: 'accrual',
  taxCalculation: 'auto',
  journalApprovalRequired: true,
  enableMultiCurrency: false,
  defaultCurrency: 'SAR',
  chartOfAccountsType: 'standard',
  reconciliationFrequency: 'monthly',
  notifyJournalEntry: true,
  notifyReconciliation: true,
  emailNotifications: true,
  restrictAccess: true,
  auditTrail: true,
  entityPrefixes: { ...DEFAULT_COMPTABILITE_ENTITY_PREFIXES },
};

export function normalizeComptabiliteConfig(raw = {}) {
  const merged = { ...DEFAULT_COMPTABILITE_CONFIG, ...raw };
  merged.entityPrefixes = {
    ...DEFAULT_COMPTABILITE_ENTITY_PREFIXES,
    ...(raw.entityPrefixes || {}),
  };
  return merged;
}

/** Map module prefixes into global entityPrefixes keys used by generateEntityReference. */
export function buildComptabiliteEntityPrefixes(config) {
  const c = normalizeComptabiliteConfig(config);
  return { ...c.entityPrefixes };
}

export function getComptabiliteEntityPrefix(settings, entityKey, fallback) {
  const fromAccounting = settings?.accounting?.entityPrefixes?.[entityKey];
  if (fromAccounting) return String(fromAccounting).trim() || fallback;
  return settings?.configuration?.entityPrefixes?.[entityKey] || fallback;
}
